import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Container, Spinner, Modal, Button } from "react-bootstrap";
import { es } from "date-fns/locale";
import { useLocation } from "react-router-dom";

// ✅ RUTA CORREGIDA: Apunta exactamente a tu archivo masajes.js
import { listaMasajes } from "../../assets/data/masajes"; 

import {
  supabase,
  validarTelefono,
  formatFechaKey,
  fetchCitasPorDia,
  fetchCitasPorFecha,
} from "../../services/citaService";
import FormularioCliente from "../../components/ui/FormularioCliente";

// =========================================================================
// ✅ FUNCIONES AUXILIARES FUERA DEL COMPONENTE (Evita alertas de ESLint)
// =========================================================================

const obtenerConfiguracionDia = (date, horarioBase, excepciones) => {
  if (!date) return { abierto: false };
  const fechaStr = formatFechaKey(date);

  const excepcion = excepciones.find((e) => e.fecha === fechaStr);
  if (excepcion) {
    return {
      abierto: excepcion.abierto,
      horaInicio: excepcion.hora_inicio,
      horaFin: excepcion.hora_fin,
    };
  }

  const diaSemana = date.getDay();
  const base = horarioBase.find((b) => b.dia_semana === diaSemana);
  if (base) {
    return {
      abierto: base.abierto,
      horaInicio: base.hora_inicio,
      horaFin: base.hora_fin,
    };
  }
  return { abierto: false };
};

const generarSlots30Min = (horaInicio, horaFin) => {
  if (!horaInicio || !horaFin) return [];
  const slots = [];
  let [hIn, mIn] = horaInicio.split(":").map(Number);
  const [hFin, mFin] = horaFin.split(":").map(Number);
  
  let minutosActuales = hIn * 60 + mIn;
  const minutosFinales = hFin * 60 + mFin;
  
  while (minutosActuales < minutosFinales) {
    const h = Math.floor(minutosActuales / 60);
    const m = minutosActuales % 60;
    slots.push(`${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`);
    minutosActuales += 30;
  }
  return slots;
};

const calcularHoraFinReal = (horaInicio, minutosDuracion) => {
  if (!horaInicio) return "";
  let [h, m] = horaInicio.split(":").map(Number);
  let totalMinutos = h * 60 + m + minutosDuracion;
  return `${String(Math.floor(totalMinutos / 60)).padStart(2, "0")}:${String(totalMinutos % 60).padStart(2, "0")}`;
};

const encontrarProximaDisponibilidad = (horarioBase, excepciones, conteo, duracionBloqueReq) => {
  const slotsNecesarios = duracionBloqueReq / 30;
  const inicioSec = new Date();

  for (let i = 1; i <= 45; i++) {
    const d = new Date();
    d.setDate(inicioSec.getDate() + i);
    d.setHours(0, 0, 0, 0);

    const config = obtenerConfiguracionDia(d, horarioBase, excepciones);
    if (config.abierto) {
      const key = formatFechaKey(d);
      const todosLosSlots = generarSlots30Min(config.horaInicio, config.horaFin);
      const citasExistentes = conteo[key] || 0;

      if (citasExistentes * 2 < todosLosSlots.length && todosLosSlots.length >= slotsNecesarios) {
        return d;
      }
    }
  }
  return null;
};

// =========================================================================
// COMPONENTE PRINCIPAL
// =========================================================================
const CitaScreen = () => {
  const [horarioSemanal, setHorarioSemanal] = useState([]);
  const [fechasExcepcion, setFechasExcepcion] = useState([]);
  
  const [selectedDate, setselectedDate] = useState(null);
  const [conteoCitas, setConteoCitas] = useState({});
  const [loading, setLoading] = useState(true);
  const [codigoInput, setCodigoInput] = useState("");
  const [mostrarInputCodigo, setMostrarInputCodigo] = useState(false);
  const [idCitaRecienCreada, setIdCitaRecienCreada] = useState(null);
  const [contadorTiempo, setContadorTiempo] = useState(300);
  const [cargandoBloques, setCargandoBloques] = useState(false);
  const [bloquesDisponibles, setBloquesDisponibles] = useState([]);
  const [fechaInicialSugerida, setFechaInicialSugerida] = useState(null);
  const [citaConfirmada, setCitaConfirmada] = useState(false);

  // Estados de formulario
  const [bloqueSeleccionado, setBloqueSeleccionado] = useState(null);
  const [nombre, setNombre] = useState("");
  const [primerApellido, setPrimerApellido] = useState("");
  const [segundoApellido, setSegundoApellido] = useState("");
  const [telefono, setTelefono] = useState("");
  const [telefonoValido, setTelefonoValido] = useState(true);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [tipoMasaje, setTipoMasaje] = useState(queryParams.get("tipo") || "");
  const [comentarioCliente, setComentarioCliente] = useState("");

  const [mostrarModal, setMostrarModal] = useState(false);
  const [tituloModal, setTituloModal] = useState("");
  const [mensajeModal, setMensajeModal] = useState("");

  const mostrarPopup = (titulo, mensaje) => {
    setTituloModal(titulo);
    setMensajeModal(mensaje);
    setMostrarModal(true);
  };

  const masajeSeleccionado = listaMasajes.find(
    (m) => m.title === tipoMasaje || m.altTitle === tipoMasaje
  );

  // 1. CARGA INICIAL (Solo se ejecuta al montar el componente)
  useEffect(() => {
    const cargarDatos = async () => {
      setLoading(true);
      const [resSemana, resExcepciones, conteo] = await Promise.all([
        supabase.from("horario_semanal").select("*"),
        supabase.from("dias_excepcion").select("*"),
        fetchCitasPorDia(),
      ]);

      const baseSemana = resSemana.data || [];
      const excepciones = resExcepciones.data || [];
      const blocksRequeridos = masajeSeleccionado ? masajeSeleccionado.duracionBloque : 60;

      setHorarioSemanal(baseSemana);
      setFechasExcepcion(excepciones);
      setConteoCitas(conteo || {});

      const proximaFecha = encontrarProximaDisponibilidad(baseSemana, excepciones, conteo || {}, blocksRequeridos);
      if (proximaFecha) {
        setFechaInicialSugerida(proximaFecha);
        setselectedDate(proximaFecha);
      }
      setLoading(false);
    };
    cargarDatos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 2. EFECTO REACTIVO: CALCULA HUECOS BASADO EN FECHA + MASAJE SELECCIONADO
  useEffect(() => {
    const calcularSlotsDisponibles = async () => {
      if (!selectedDate || horarioSemanal.length === 0) return;
      setCargandoBloques(true);

      const config = obtenerConfiguracionDia(selectedDate, horarioSemanal, fechasExcepcion);
      if (!config.abierto) {
        setBloquesDisponibles([]);
        setCargandoBloques(false);
        return;
      }

      const todosLosSlots = generarSlots30Min(config.horaInicio, config.horaFin);
      const citas = await fetchCitasPorFecha(selectedDate);
      const slotsOcupados = new Set();

      citas.forEach((cita) => {
        const hInicio = new Date(cita.hora).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false });
        const infoMasaje = listaMasajes.find((m) => m.title === cita.tipo_de_masaje || m.altTitle === cita.tipo_de_masaje);
        const duracionB = infoMasaje ? infoMasaje.duracionBloque : 60; 
        const tramosOcupados = duracionB / 30;

        let indexInicio = todosLosSlots.indexOf(hInicio);
        if (indexInicio !== -1) {
          for (let i = 0; i < tramosOcupados; i++) {
            if (indexInicio + i < todosLosSlots.length) {
              slotsOcupados.add(todosLosSlots[indexInicio + i]);
            }
          }
        }
      });

      const bloqueActualRequerido = masajeSeleccionado ? masajeSeleccionado.duracionBloque : 60;
      const slotsNecesarios = bloqueActualRequerido / 30;

      const disponibles = todosLosSlots.filter((slot, idx) => {
        for (let i = 0; i < slotsNecesarios; i++) {
          const targetIndex = idx + i;
          if (targetIndex >= todosLosSlots.length || slotsOcupados.has(todosLosSlots[targetIndex])) {
            return false;
          }
        }
        return true;
      });

      setBloquesDisponibles(disponibles);
      
      if (disponibles.length > 0) {
        setBloqueSeleccionado(disponibles[0]);
      } else {
        setBloqueSeleccionado(null);
      }
      setSizeBloques(disponibles);
      setCargandoBloques(false);
    };

    const setSizeBloques = (disp) => {};

    calcularSlotsDisponibles();
  }, [selectedDate, tipoMasaje, horarioSemanal, fechasExcepcion, masajeSeleccionado]);

  // Contador SMS
  useEffect(() => {
    if (mostrarInputCodigo && contadorTiempo > 0) {
      const interval = setInterval(() => setContadorTiempo((prev) => prev - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [mostrarInputCodigo, contadorTiempo]);

  const handleSeleccionFecha = (date) => {
    setBloqueSeleccionado(null);
    setselectedDate(date);
  };

  const handleTelefonoChange = (e) => {
    const valor = e.target.value;
    setTelefono(valor);
    setTelefonoValido(validarTelefono(valor));
  };

  const getClassForDate = (date) => {
    if (loading) return "";
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    if (date <= hoy) return "";

    const fechaLimite = new Date(hoy.getFullYear(), hoy.getMonth() + 3, 0);
    if (date > fechaLimite) return "";

    const key = formatFechaKey(date);
    const config = obtenerConfiguracionDia(date, horarioSemanal, fechasExcepcion);
    if (!config.abierto) return "";

    const todosLosSlots = generarSlots30Min(config.horaInicio, config.horaFin);
    if (todosLosSlots.length === 0) return "";

    const citasEnDia = conteoCitas[key] || 0;
    if (citasEnDia * 2 >= todosLosSlots.length) return "rojo";
    if (citasEnDia * 2 >= todosLosSlots.length / 2) return "amarillo";
    return "verde";
  };

  const insertarCita = async () => {
    if (!bloqueSeleccionado || !selectedDate || !nombre || !primerApellido || !telefono || !telefonoValido || !tipoMasaje) {
      mostrarPopup("Campos incompletos", "Por favor, completa correctamente todos los campos.");
      return;
    }

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    if (new Date(selectedDate) <= hoy) {
      mostrarPopup("Reserva no permitida", "No es posible reservar para el día en curso.");
      return;
    }

    const ahora = new Date();
    const offsetMs = ahora.getTimezoneOffset() * 60000;
    const ahoraISO = new Date(ahora.getTime() - offsetMs).toISOString().slice(0, 19);

    const { count, error: errorCheck } = await supabase
      .from("citas")
      .select("*", { count: "exact", head: true })
      .eq("telefono", telefono)
      .gte("hora", ahoraISO);

    if (errorCheck || count >= 3) {
      mostrarPopup("Límite alcanzado o Error", "No se pueden añadir más citas o hubo un error de verificación.");
      return;
    }

    const [hours, minutes] = bloqueSeleccionado.split(":");
    const fechaLocal = new Date(selectedDate);
    fechaLocal.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
    const horaLocalISO = new Date(fechaLocal.getTime() - offsetMs).toISOString().slice(0, 19);

    const codigoVerificacion = Math.floor(100000 + Math.random() * 900000).toString();

    const { data, error } = await supabase.from("citas").insert([{
      nombre, primer_apellido: primerApellido, segundo_apellido: segundoApellido,
      telefono, tipo_de_masaje: tipoMasaje, hora: horaLocalISO, ha_pagado: false,
      codigo_verificacion: codigoVerificacion, confirmada: false, comentario_cliente: comentarioCliente,
    }]).select();

    if (error) {
      mostrarPopup("Error", "Ha ocurrido un error al guardar la cita.");
    } else {
      setIdCitaRecienCreada(data[0].id);
      setMostrarInputCodigo(true);
      setContadorTiempo(300);
      mostrarPopup("Verificación necesaria", "Se te enviará un código por SMS.");

      await fetch(`${process.env.REACT_APP_SUPABASE_URL}/functions/v1/enviar-sms`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        mode: 'cors',
        body: JSON.stringify({ telefono: '+34' + telefono, nombre, hora: horaLocalISO.replace("T", " ").slice(0, 16), codigoVerificacion }),
      });
    }
  };

  const confirmarCodigo = async () => {
    const { data, error } = await supabase
      .from("citas")
      .update({ confirmada: true })
      .eq("id", idCitaRecienCreada)
      .eq("codigo_verificacion", String(codigoInput))
      .select();

    if (error || !data || data.length === 0) {
      mostrarPopup("Error", "Código incorrecto o error en servidor.");
      return;
    }

    setMostrarInputCodigo(false);
    setCitaConfirmada(true);

    try {
      const cita = data[0];
      await fetch(`${process.env.REACT_APP_SUPABASE_URL}/functions/v1/notificar-reserva`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "x-secret-key": "mf2025_secret" },
        body: JSON.stringify({ nombre: cita.nombre, telefono: cita.telefono, tipo_de_masaje: cita.tipo_de_masaje, hora: cita.hora }),
      });
    } catch (e) { console.error(e); }

    if (window.gtag_report_conversion) window.gtag_report_conversion();
  };

  if (citaConfirmada) {
    return (
      <Container style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "40px" }} className="my-8">
        <div style={{ textAlign: "center", maxWidth: "450px", padding: "30px", border: "1px solid #e3e3e3", borderRadius: "10px", backgroundColor: "#f8f9fa" }}>
          <div style={{ fontSize: "50px", color: "#28a745", marginBottom: "15px" }}>✓</div>
          <h3 style={{ color: "#28a745", marginBottom: "15px", fontWeight: "bold" }}>¡Reserva Confirmada!</h3>
          <h5>Muchas gracias por confiar en nosotros.</h5>
          <p style={{ marginTop: "15px", color: "#6c757d", fontSize: "14px" }}> Tu cita se ha registrado correctamente en el sistema.</p>
          <a className="btn btn-hero" href="/cita">Entendido</a>
        </div>
      </Container>
    );
  }

  if (mostrarInputCodigo) {
    return (
      <Container style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "20px" }} className="my-8">
        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <h5 style={{ marginBottom: "15px" }}>Verificación de seguridad</h5>
          <p>Introduce el código por SMS (expira en {Math.floor(contadorTiempo / 60)}:{String(contadorTiempo % 60).padStart(2, "0")})</p>
          <input
            type="text"
            placeholder="Código"
            value={codigoInput}
            onChange={(e) => setCodigoInput(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") confirmarCodigo(); }}
            style={{ width: "200px", padding: "8px" }}
          />
          <button onClick={confirmarCodigo} style={{ padding: "10px 20px", marginLeft: "10px", backgroundColor: "#28a745", color: "white", border: "none", borderRadius: "5px" }}>
            Confirmar código
          </button>
        </div>
        <Modal show={mostrarModal} onHide={() => setMostrarModal(false)} centered>
          <Modal.Header closeButton><Modal.Title>{tituloModal}</Modal.Title></Modal.Header>
          <Modal.Body>{mensajeModal}</Modal.Body>
          <Modal.Footer><Button variant="primary" onClick={() => setMostrarModal(false)}>Aceptar</Button></Modal.Footer>
        </Modal>
      </Container>
    );
  }

  const minutosDuracionReal = masajeSeleccionado ? masajeSeleccionado.duracion : 60;

  return (
    <Container style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "20px" }} className="my-8">
      <h5 style={{ marginBottom: "20px" }}>Selecciona una fecha:</h5>

      <div style={{ marginBottom: "10px", height: "250px" }}>
        {loading ? (
          <Spinner animation="border" role="status" />
        ) : (
          <DatePicker
            locale={es}
            selected={selectedDate}
            onChange={handleSeleccionFecha}
            inline
            dayClassName={getClassForDate}
            filterDate={(d) => obtenerConfiguracionDia(d, horarioSemanal, fechasExcepcion).abierto}
            minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
            maxDate={new Date(new Date().getFullYear(), new Date().getMonth() + 3, 0)}
          />
        )}
      </div>

      {selectedDate && (
        <div style={{ marginTop: "20px", width: "100%", textAlign: "center" }}>
          {cargandoBloques ? (
            <div style={{ textAlign: "center", marginTop: "20px" }}><Spinner animation="border" /><p>Cargando disponibilidad...</p></div>
          ) : bloquesDisponibles.length > 0 ? (
            <div>
              <h5 style={{ marginBottom: "20px" }}>Selecciona una hora para el día {selectedDate.toLocaleDateString()}:</h5>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "15px", justifyContent: "center" }}>
                {bloquesDisponibles.map((hora, index) => {
                  const esSugerenciaInicial = selectedDate && fechaInicialSugerida &&
                    selectedDate.toDateString() === fechaInicialSugerida.toDateString() &&
                    index === 0;

                  return (
                    <div key={hora} style={{ position: "relative" }}>
                      {esSugerenciaInicial && (
                        <span style={{
                          position: "absolute",
                          top: "-15px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          backgroundColor: "#ffc107",
                          color: "#212529",
                          fontSize: "9px",
                          padding: "1px 5px",
                          borderRadius: "3px",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                          zIndex: 2,
                          boxShadow: "0px 1px 3px rgba(0,0,0,0.15)"
                        }}>
                          1ª DISPONIBILIDAD
                        </span>
                      )}

                      <button
                        onClick={() => setBloqueSeleccionado(hora)}
                        style={{
                          padding: "10px",
                          borderRadius: "5px",
                          backgroundColor: bloqueSeleccionado === hora ? "#28a745" : "#007bff",
                          color: "white",
                          border: "none",
                          cursor: "pointer",
                          minWidth: "120px"
                        }}
                      >
                        {hora} - {calcularHoraFinReal(hora, minutosDuracionReal)}
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : <p>No hay tramos horarios lo suficientemente largos disponibles para este masaje hoy.</p>}
        </div>
      )}

      <FormularioCliente
        nombre={nombre} setNombre={setNombre}
        primerApellido={primerApellido} setPrimerApellido={setPrimerApellido}
        segundoApellido={segundoApellido} setSegundoApellido={setSegundoApellido}
        telefono={telefono} handleTelefonoChange={handleTelefonoChange}
        telefonoValido={telefonoValido} tipoMasaje={tipoMasaje} setTipoMasaje={setTipoMasaje}
        comentarioCliente={comentarioCliente} setComentarioCliente={setComentarioCliente}
      />

      {selectedDate && (
        <button
          onClick={insertarCita}
          disabled={!bloqueSeleccionado || !nombre || !primerApellido || !telefonoValido || !tipoMasaje}
          style={{ marginTop: "15px", padding: "10px 20px", backgroundColor: (!bloqueSeleccionado || !nombre || !primerApellido || !telefono || !telefonoValido || !tipoMasaje) ? "#ccc" : "#28a745", color: "white", border: "none", borderRadius: "5px", cursor: (!bloqueSeleccionado || !nombre || !primerApellido || !telefono || !telefonoValido || !tipoMasaje) ? "not-allowed" : "pointer" }}
        >
          Guardar Cita
        </button>
      )}

      <Modal show={mostrarModal} onHide={() => setMostrarModal(false)} centered>
        <Modal.Header closeButton><Modal.Title>{tituloModal}</Modal.Title></Modal.Header>
        <Modal.Body>{mensajeModal}</Modal.Body>
        <Modal.Footer><Button variant="primary" onClick={() => setMostrarModal(false)}>Aceptar</Button></Modal.Footer>
      </Modal>
    </Container>
  );
};

export default CitaScreen;